<template>
  <page-layout>
    <side-bar
        slot="page_side_bar"
        :side-options="mSideOption.options"
        v-on:click="onClickNav">
    </side-bar>
    <!-- router view is page content -->
    <router-view slot="page_content">
    </router-view>
  </page-layout>
</template>

<script>

import PageLayout from "@/components/page_layout"
import SideBar from "@/components/side_bar"
import Diagnostics from "@/views/content/diagnostics"
import Inventory from "@/views/content/inventory"
import PlaceHolder from "@/views/content/place_holder"
import logger from "@/util/logger"

const LOG_TAG = 'customer_services';

export default {
  name: LOG_TAG,
  components: {
    PageLayout,
    SideBar,
  },
  props: {
  },
  data() {
    return {
      mSideOption: {
        options: [
          {text: Diagnostics.display, value: Diagnostics.route},
          {text: Inventory.display, value: Inventory.route},
          {text: PlaceHolder.display, value: PlaceHolder.route},
        ],
      }
    };
  },
  mounted() {
    const vm = this;
    // logger.d(LOG_TAG, 'mounted', vm.$route.name);
    vm.onClickNav(vm.$route.name);
  },
  methods: {
    onClickNav(value) {
      const vm = this;
      logger.d(LOG_TAG, 'onClickNav', value);
      switch (value) {
        case Diagnostics.route:
          vm.$router.replace({name: value}, () => {});
          break;
        case Inventory.route:
          vm.$router.replace({name: value}, () => {});
          break;
        case PlaceHolder.route:
          vm.$router.replace({name: value}, () => {});
          break;
        default:
          vm.$router.replace({name: Diagnostics.route}, () => {});
      }
    },
  }
}
</script>

<style scoped>
</style>
